import React, { useEffect } from "react";
import styled from "styled-components";
import Layout from "../components/Layout";
import Spacer from "@components/common/Spacer";
import fp from "lodash/fp";
import Link from "@components/Link";
import RequestsTable from "@components/RequestsTable";
import UserContext from "@contexts/user";
import { navigate } from "gatsby";
import moment from "moment-timezone";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr min(1110px, calc(100% - 32px)) 1fr;
  grid-column-gap: 16px;
  & > * {
    grid-column: 2;
  }
`;

const LinkWrapper = styled.div`
  padding: 7px;

  a {
    display: block;
    margin-left: auto;
  }
`;

const TableWrapper = styled.div``;

// markup
const MyPage = props => {
  const { state } = props.location;
  const { user } = React.useContext(UserContext);
  const [requests, setRequests] = React.useState([]);
  const [today, setToday] = React.useState("");

  useEffect(() => {
    setToday(moment.tz(new Date(), "Asia/Seoul").format().split("T")[0]);

    if (fp.isEmpty(user)) {
      alert("사용자 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      navigate("/login", { state: { source: "/user" } });
    }
  }, []);

  useEffect(() => {
    if (
      !fp.isEmpty(state) &&
      !fp.isEmpty(state.requests) &&
      !fp.isEmpty(state.events) &&
      !fp.isEmpty(user)
    ) {
      const eventsObj = fp.keyBy("id", state.events);

      setRequests(
        fp.flow(
          fp.filter(request => request.email === user.getEmail()),
          fp.map(request =>
            fp.assign(request, { date: eventsObj[request.eventId]["date"] })
          ),
          fp.orderBy(["date"], ["asc"])
        )(state.requests)
      );
    }
  }, [state]);

  return (
    <Layout>
      <Wrapper>
        {/*<Loading loading={isLoading}></Loading>*/}
        <LinkWrapper>
          <Link to={"/user"}>메인화면</Link>
        </LinkWrapper>
        <Spacer axis={"vertical"} size={20} />
        {/*{!fp.isEmpty(state) && !fp.isEmpty(state.requests) && (*/}
        {!fp.isEmpty(requests) && (
          <TableWrapper>
            <RequestsTable
              requests={requests} //{state.requests}
              loading={true /* isLoading */}
              header={`신청목록`}
              source={"/user"}
              today={today}
            />
          </TableWrapper>
        )}
        {/*{!isLoading && !fp.isEmpty(data) && (*/}
        {/*  <TableWrapper>*/}
        {/*    <RequestsTable*/}
        {/*      requests={data}*/}
        {/*      loading={isLoading}*/}
        {/*      header={`신청목록 (${state.eventId})`}*/}
        {/*    />*/}
        {/*  </TableWrapper>*/}
        {/*)}*/}
      </Wrapper>
    </Layout>
  );
};

export default MyPage;
